import { ApSettingsPage } from './ApSettingsPage';

import type { OrdResourceProps } from '@ragu-components/ord-resources';

export const apSettingsResource: OrdResourceProps = {
  key: 'ap_settings',
  name: 'ap_settings',
  list: <ApSettingsPage />,
  options: {},
};
